import { CardSvg } from '@/play/cardSvg'

/**
 * Home card art for Right way (no text): a sheet with a faint A in it; a blue line traced down the
 * left leg the right way is glassy (lighter, with a shine), a scribble off the letter is plain ink.
 */
export function RightWayCardArt() {
  return (
    <CardSvg bg="#e9e1d2">
      <path d="M40 176 L 78 40 H 262 L 290 176 Z" fill="#f7f2e6" />
      {/* the letter, pressed faintly into the paper */}
      <path d="M168 58 L 128 158 M168 58 L 210 158 M143 120 H 194" stroke="#e6dabd" strokeWidth="9" strokeLinecap="round" fill="none" />
      {/* traced the right way: glassy */}
      <path d="M168 58 L 136 138" stroke="#7fa6ec" strokeWidth="8" strokeLinecap="round" fill="none" opacity="0.85" />
      <path d="M165 66 L 140 128" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" fill="none" opacity="0.8" />
      {/* a scribble off the letter: plain ink */}
      <path d="M70 150 C 84 128, 98 160, 108 138" stroke="#2f6fde" strokeWidth="7" strokeLinecap="round" fill="none" />
    </CardSvg>
  )
}
